<template>
  <div class="fontting">
    <div class="fontting-tab">
      <div style="display: flex;flex-wrap: nowrap;">
        <div class="control-item" @click="edit">
          <div class="control-item-icon">
          </div>
          <div class="control-item-title">
            编辑
          </div>
        </div>
        <div class="control-item" @click="fullscreen">
          <div class="control-item-icon">
          </div>
          <div class="control-item-title">
            全屏
          </div>
        </div>

      </div>
    </div>

  </div>

</template>

<script>
  import {mapState} from 'vuex'

  export default {

    methods: {
      edit() {
        this.$emit('edit')
      },
      fullscreen() {
        this.$emit('fullscreen')
      },
    },

    computed: {
      ...mapState({
        controlIndex: state => state.controlIndex,
        componentsList: state => state.componentsList,
      }),
    },
  }
</script>

<style lang="scss">
  @import "../../public/static/css/app";

  .fontting {
    position: fixed;
    z-index: 50;
    width: 100%;
    height: 50px;
    white-space: nowrap;

    .fontting-tab {
      height: 50px;
      border-top: 1px solid $uni-text-color-placeholder;
      position: fixed;
      white-space: nowrap;
      overflow-x: auto;
      width: 100%;
      bottom: 0;
      left: 0;
      z-index: 30;
      background: #F8F9FD;

      .control-item {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 50px;

        .control-item-title {
          font-size: 14px;
        }
      }
    }

  }

</style>
